// A cached formatter for intraday data
var dateTimeFormatterIntraday = Intl.DateTimeFormat('en', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
});
// A cached formatter for non-intraday data
var dateTimeFormatter = Intl.DateTimeFormat('en', {
    month: '2-digit',
    day: '2-digit',
});
/**
 * Config of ChartIQ DataProvider
 */
var ChartIQContentDataProviderConfig = /** @class */ (function () {
    /**
     * Constructor
     * @param version
     */
    function ChartIQContentDataProviderConfig(version) {
        if (version === void 0) { version = 'v1'; }
        this.API_VERSION = version;
        this.API_INSTRUMENT_GET_BY_NOTATION = "/api/" + this.API_VERSION + "/instrument/getByNotation";
        this.API_PRICES_TRADING_SCHEDULE_EVENT_LIST = "/api/" + this.API_VERSION + "/prices/tradingSchedule/event/list";
        this.API_PRICES_TSS_CHART_IQ_EOD_LIST = "/api/" + this.API_VERSION + "/vendor/chartIQ/timeSeries/eod/list";
        this.API_PRICES_TSS_CHART_IQ_INTRADAY_SUBSAMPLE_LIST = "/api/" + this.API_VERSION + "/vendor/chartIQ/timeSeries/intraday/subsample/list";
        this.API_NOTATION = "/api/" + this.API_VERSION + "/notation/get";
        this.API_BASIC_MARKET = "/api/" + this.API_VERSION + "/basic/market/get";
        this.API_PRICES_SUBSCRIPTION_ENDPOINT = "/api/" + this.API_VERSION + "/prices/get";
        this.API_PRICES_QUALITY = 'BST';
        this.API_PRICES_LAST_YEARS = 20;
        this.API_PRICES_LAST_DAYS = 10;
        this.API_PRICES_REQUEST_CHUNK_YEARS = 5;
        this.API_PRICES_REQUEST_CHUNK_DAYS = 2;
        this.FUNC_FORMAT_VALUE = null;
        this.FUNC_FORMAT_DATE_TIME = ChartIQContentDataProviderConfig.defaultDateFormatter;
    }
    ChartIQContentDataProviderConfig.defaultDateFormatter = function (time, intraday) {
        return intraday ? dateTimeFormatterIntraday.format(time) : dateTimeFormatter.format(time);
    };
    return ChartIQContentDataProviderConfig;
}());
export { ChartIQContentDataProviderConfig };
//# sourceMappingURL=ChartIQContentDataProviderConfig.js.map